import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  Menu,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import React from "react";
import SwitchToggle from "../../components/SwitchToggle";

const linkedUsers = [
  {
    id: "u1",
    name: "Alex Johnson",
    relation: "Partner",
    role: "partner",
    permissions: {
      goals: true,
      budgets: false,
      calendar: true,
    },
  },
  {
    id: "u2",
    name: "Emily Johnson",
    relation: "Child",
    role: "viewer",
    permissions: {
      goals: false,
      budgets: false,
      calendar: false,
    },
  },
];

const RecentActivities = () => {
  const navigate = useNavigate();
  const [resetOpen, setResetOpen] = React.useState(false);
  const [editRoleOpen, setEditRoleOpen] = React.useState(false);

  const [Status, setStatus] = React.useState("default");
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  const users = [
    {
      id: 1,
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      activity: "Logout",

      date: "01 March 2025",
      time: "10:15 AM",

    },
    {
      id: 2,
      name: "John Smith",
      email: "john@example.com",
      phone: "+91 9000011111",
      activity: "Change Password",

      date: "01 March 2025",
      time: "03:42 PM",

    },
  ];

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [menuRowId, setMenuRowId] = React.useState<number | null>(null);
  const open = Boolean(anchorEl);
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: number
  ) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(rowId);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>DOB</TableCell>
              <TableCell>Last Activity</TableCell>
              <TableCell>Timestamp</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow hover key={user.id}>
                <TableCell>
                  <a
                    href="/manage-users/detail"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/manage-users/detail", { state: { user } });
                    }}
                    className="user_block click_action"
                  >
                    <p>
                      <b>{user.name}</b>
                      <span>{user.email}</span>
                      <span>{user.phone}</span>
                    </p>
                  </a>
                </TableCell>
                <TableCell>{user.date}</TableCell>
                <TableCell>{user.activity}</TableCell>
                <TableCell>
                  {user.date} , {user.time}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default RecentActivities;
